import React from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs,doc,getDoc,updateDoc } from "firebase/firestore";
import { db, auth } from "../firebase";
import { useEffect, useState,useRef  } from "react";
import { addDoc, serverTimestamp } from "firebase/firestore";
import { trackClick } from './trackClick';
import {  RecaptchaVerifier, signInWithPhoneNumber,onAuthStateChanged  } from "firebase/auth";
import {  PhoneAuthProvider,  linkWithCredential} from "firebase/auth";

import { getCountFromServer } from "firebase/firestore";
import { BookOpen, Download, IndianRupee, Info } from "lucide-react";





// --- CONFIGURATION & PLACEHOLDER DATA ---




// REPLACE THESE WITH YOUR ACTUAL IMAGE PATHS
// e.g., import unlockedImg from '../assets/chest-open.png';
const unlockedImage = "../Open_Gift_Box.jpg"; // Colorful treasure chest
const lockedImage = "../Closed_Gift_Box.jpg"; // Using same for now, will apply greyscale filter in styles
const specialImage = "../Gift_Card.jpg"; // image for multiples of 10


// Generate dummy data for 25 stops.
// In a real app, you'd fetch user progress to determine what's unlocked.


// --- SVG LAYOUT CALCULATIONS ---
// These define the canvas size and how the road curves
const SVG_WIDTH = 600; // Wide enough for the curve
const STOP_HEIGHT_SPACING = 120; // Vertical space between stops
const START_Y_PADDING = 100;
const CENTER_X = SVG_WIDTH / 2;
const CURVE_AMPLITUDE = 180; // How wide the road swings left/right

const getNextMultipleOf10 = (num) => Math.ceil(num / 10) * 10;



// Helper to calculate the exact X,Y coordinate for a specific stop number (index)
const getStopCoordinate = (index, totalStops) => {
  const y = START_Y_PADDING + index * STOP_HEIGHT_SPACING;
  const xOffset = Math.sin(index / 2.5) * CURVE_AMPLITUDE;
  const x = CENTER_X + xOffset;
  return { x, y };
};

const generateRoadPath = (totalStops) => {
  let pathStr = `M ${CENTER_X},${START_Y_PADDING} `;
  for (let i = 0; i < totalStops; i++) {
    const current = getStopCoordinate(i, totalStops);
    const next = getStopCoordinate(i + 1 < totalStops ? i + 1 : i, totalStops);
    pathStr += `S ${current.x},${current.y - STOP_HEIGHT_SPACING/2} ${current.x},${current.y} `;
  }
  return pathStr;
};

function RewardJourney() {
  const navigate = useNavigate();

  const [monetizationStats, setMonetizationStats] = useState({
  lessonCount: 0,
  worksheetCount: 0,
  totalDownloadsCount: 0,
});

const [loadingMonetization, setLoadingMonetization] = useState(false);

useEffect(() => {
  let active = true;

  const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
    if (!currentUser?.uid || currentUser.email !== "eascode.ltd@gmail.com") {
      if (active) {
        setMonetizationStats({
          lessonCount: 0,
          worksheetCount: 0,
          totalDownloadsCount: 0,
        });
        setLoadingMonetization(false);
      }
      return;
    }

    setLoadingMonetization(true);

    try {
      const [lessonsSnap, worksheetsSnap, publicProfileSnap] =
        await Promise.all([
          getCountFromServer(
            query(
              collection(db, "Saved_lessons"),
              where("uid", "==", currentUser.uid)
            )
          ),
          getCountFromServer(
            query(
              collection(db, "uploads"),
              where("uid", "==", currentUser.uid)
            )
          ),
          getDoc(doc(db, "public_profiles", currentUser.uid)),
        ]);

      if (active) {
        setMonetizationStats({
          lessonCount: lessonsSnap.data().count || 0,
          worksheetCount: worksheetsSnap.data().count || 0,
          totalDownloadsCount: publicProfileSnap.exists()
            ? publicProfileSnap.data().totalDownloads || 0
            : 0,
        });
      }
    } catch (error) {
      console.error("Error fetching monetization stats:", error);
    } finally {
      if (active) setLoadingMonetization(false);
    }
  });

  return () => {
    active = false;
    unsubscribe();
  };
}, []);

  const [journeyData, setJourneyData] = useState([]);
  const [claimedRewards, setClaimedRewards] = useState([]);
  const [finalReward, setFinalReward] = useState(null);
  const [sendingOtp, setSendingOtp] = useState(false);

  const [rewardsDisabled, setRewardsDisabled] = useState(false);
const [checkingRewardAccess, setCheckingRewardAccess] = useState(true);

useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
    if (!currentUser) {
      setCheckingRewardAccess(false);
      return;
    }

    try {
      const profileSnap = await getDoc(doc(db, "profiles", currentUser.uid));
      setRewardsDisabled(profileSnap.exists() && profileSnap.data().paidUser === true);
    } catch (error) {
      console.error("Error checking rewards access:", error);
    } finally {
      setCheckingRewardAccess(false);
    }
  });

  return () => unsubscribe();
}, []);



  const scrollRef = useRef(null);
  const lastStopRef = useRef(null);

  const START_POINTER_Y = 30; // always just below top of SVG


  const TOTAL_STOPS = journeyData.length;


  // SVG Height depends on TOTAL_STOPS
  const SVG_HEIGHT = START_Y_PADDING + (TOTAL_STOPS * STOP_HEIGHT_SPACING) + 100;

  const roadPathD = generateRoadPath(TOTAL_STOPS);

  const [showGift, setShowGift] = useState(false);
  const [activeGift, setActiveGift] = useState(null);

  const [otpStep, setOtpStep] = useState(null); 
// null | "PHONE" | "OTP"

const [phone, setPhone] = useState("");
const [otp, setOtp] = useState("");
const [otpError, setOtpError] = useState("");

const recaptchaVerifier = useRef(null);
const [confirmationResult, setConfirmationResult] = useState(null);
const [selectedRewardIndex, setSelectedRewardIndex] = useState(null);





useEffect(() => {
  if (showGift && !recaptchaVerifier.current) {
    recaptchaVerifier.current = new RecaptchaVerifier(
      auth,
      "recaptcha-container",
      { size: "invisible" }
    );
  }
}, [showGift]);



const checkPhoneUniqueness = async (phone) => {
  // 1️⃣ Check if this phone is already linked
  const phoneQuery = query(
    collection(db, "User_Phone_Map"),
    where("phone", "==", phone)
  );
  const phoneSnap = await getDocs(phoneQuery);

  if (!phoneSnap.empty) {
    const existing = phoneSnap.docs[0].data();
    if (existing.uid !== auth.currentUser.uid) {
      // Phone belongs to another user → block
      return {
        allowed: false,
        message: "This phone number is already linked to another account"
      };
    }
    // Phone belongs to same user → allow (do nothing)
  }

  // 2️⃣ Check if user already linked a **different phone**
  const userQuery = query(
    collection(db, "User_Phone_Map"),
    where("uid", "==", auth.currentUser.uid)
  );
  const userSnap = await getDocs(userQuery);

  if (!userSnap.empty) {
    const linkedPhone = userSnap.docs[0].data().phone;
    if (linkedPhone !== phone) {
      return {
        allowed: false,
        message: "You have already verified a different phone number"
      };
    }
    // Same phone → allow
  }

  return { allowed: true };
};



const originalUserRef = useRef(null);

const sendOtp = async () => {

    if (sendingOtp) return; // extra safety

  setSendingOtp(true);  

  setOtpError("");

  if (!/^[6-9]\d{9}$/.test(phone)) {
    setOtpError("Enter a valid 10-digit mobile number");
    return;
  }

    const result = await checkPhoneUniqueness(phone);

    if (!result.allowed) {
      setOtpError(result.message);
      return;
    }

  try {

    originalUserRef.current = auth.currentUser;

    if (!recaptchaVerifier.current) {
recaptchaVerifier.current = new RecaptchaVerifier(
  auth,
  "recaptcha-container",
  {
    size: "invisible",
  }
);

    }

    const formattedPhone = "+91" + phone;

    const confirmation = await signInWithPhoneNumber(
      auth,
      formattedPhone,
      recaptchaVerifier.current
    );

    setConfirmationResult(confirmation);
    setOtpStep("OTP");
  } catch (error) {
    console.error("OTP error:", error);
    setOtpError(error.message || "Failed to send OTP,Please try again");
    // allow retry
    setSendingOtp(false);
  }
};



const verifyOtp = async () => {
  setOtpError("");

  if (!otp || otp.length !== 6) {
    setOtpError("Enter valid OTP");
    return;
  }

  try {
    const credential = PhoneAuthProvider.credential(
  confirmationResult.verificationId,
  otp
);

const alreadyLinked = auth.currentUser.providerData.some(
  p => p.providerId === "phone"
);

if (!alreadyLinked) {
  await linkWithCredential(auth.currentUser, credential);
}

    // ✅ FORCE Firebase to restore original user state
    await auth.currentUser.reload();

    // 🧠 Stabilize provider priority (email / google first)
    auth.currentUser.providerData.sort((a, b) =>
      a.providerId === "password" || a.providerId === "google.com" ? -1 : 1
    );



    // ✅ OTP VERIFIED SUCCESSFULLY

    // 🔗 Link phone to user (if not exists)
    const q = query(
      collection(db, "User_Phone_Map"),
      where("phone", "==", phone)
    );

    const snap = await getDocs(q);

    if (snap.empty) {
      await addDoc(collection(db, "User_Phone_Map"), {
        uid: auth.currentUser.uid,
        email: auth.currentUser.email,
        phone,
        linkedAt: serverTimestamp()
      });
    }

    // 🚀 Proceed to reward claim
    setOtpStep(null);
    setOtp("");
    setPhone("");
    setConfirmationResult(null);
    try {
      recaptchaVerifier.current?.clear();
    } catch (e) {
      console.warn("reCAPTCHA cleanup skipped", e);
    }
    recaptchaVerifier.current = null;
    claimReward(selectedRewardIndex);


  } catch (error) {
  console.error(error);

  setOtpError("Invalid OTP. Please Resend OTP.");
 

  // 🔴 HARD RESET REQUIRED
  try {
    recaptchaVerifier.current?.clear();
  } catch {}

  recaptchaVerifier.current = null;
  setConfirmationResult(null);
  setOtp("");
}
};


  useEffect(() => {
    const fetchJourney = async () => {

      //if (checkingRewardAccess || rewardsDisabled) return;

      if (!auth.currentUser) return;

      const q = query(
        collection(db, "Reward_Capture"),
        where("uid", "==", auth.currentUser.uid)
      );

      const snapshot = await getDocs(q);

      let unlockedCount = snapshot.docs.length;
      //alert(unlockedCount);

     const totalStopsToShow = getNextMultipleOf10(unlockedCount);

      const data = [];
      for (let i = 1; i <= totalStopsToShow; i++) {
        const isUnlocked = i <= unlockedCount; // first N stops unlocked

          let imageSrc;
          if (i % 10 === 0) {
            imageSrc = specialImage;
          } else {
            imageSrc = isUnlocked ? unlockedImage : lockedImage;
          }

        data.push({
          id: i,
          label: `Level ${i}`,
          isUnlocked,
          imageSrc,
          rewardTitle: snapshot.docs[i-1]?.data()?.title || "",
        });
      }

      setJourneyData(data);
    };

    fetchJourney();


    const fetchClaimedRewards = async () => {
  if (!auth.currentUser) return;

  const q = query(
    collection(db, "Reward_Claimed"),
    where("uid", "==", auth.currentUser.uid)
  );

  const snap = await getDocs(q);
  setClaimedRewards(snap.docs.map(d => d.data()));
};

fetchClaimedRewards();


  }, []);

  useEffect(() => {
  if (lastStopRef.current) {
    lastStopRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }
}, [journeyData]);

const isLevelClaimed = (level) => {
  return claimedRewards.some(r => r.rewardLevel === level);
};

const getRewardName = (rewardIndex) => {
  if (rewardIndex === 1) return "Amazon Gift Card – 100 INR";
  if (rewardIndex === 2) return "KFC Gift Card – 100 INR";
  if (rewardIndex === 3) return "Dominos Gift Card – 100 INR";
};

const getRewardImage = (rewardIndex) => {
  if (rewardIndex === 1) return "/Amazon_Gift_Card.jpg";
  if (rewardIndex === 2) return "/KFC_Reward.png";
  if (rewardIndex === 3) return "/Dominos_Reward.png";
  return "";
};

const claimReward = async (rewardIndex) => {
  if (!auth.currentUser) return;

  const rewardName = getRewardName(rewardIndex);

  await addDoc(collection(db, "Reward_Claimed"), {
    uid: auth.currentUser.uid,
    email:auth.currentUser.email,
    rewardLevel: activeGift,
    rewardIndex,
    rewardName,
    claimedAt: serverTimestamp()
  });

  setClaimedRewards(prev => [
    ...prev,
    { rewardLevel: activeGift, rewardIndex }
  ]);

    // 👉 SHOW FINAL CONFIRMATION SCREEN
  setFinalReward({
    rewardIndex,
    rewardName
  });

};

return (
    <>
{/*
    {rewardsDisabled && (
  <div className="fixed inset-0 bg-slate-900/70 backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
    <div className="bg-white rounded-2xl p-6 sm:p-8 w-full max-w-sm text-center shadow-2xl">
      <h2 className="text-2xl font-black text-slate-800 mb-3">
        Rewards disabled
      </h2>
      <p className="text-sm text-slate-600 mb-6 leading-relaxed">
        Rewards are disabled for paid users on this account.
      </p>
      <button
        onClick={() => navigate("/Old_Home")}
        className="w-full bg-indigo-600 text-white font-bold py-3 rounded-xl hover:bg-indigo-700 transition-colors"
      >
        Go back to home
      </button>
    </div>
  </div>
)}

*/}
      {/* 🔹 Inject Keyframes for pulsing animation */}
      <style>
        {`
          @keyframes svgPulse {
            0% { stroke-width: 3; stroke-opacity: 1; }
            50% { stroke-width: 8; stroke-opacity: 0.5; }
            100% { stroke-width: 3; stroke-opacity: 1; }
          }
          .pulsing-circle {
             animation: svgPulse 2s infinite ease-in-out;
          }
        `}
      </style>

      {/* Recaptcha container (Hidden from flow) */}
      <div id="recaptcha-container" className="hidden"></div>

      <div className="min-h-screen flex flex-col bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-indigo-50 via-slate-50 to-white font-sans">
        
        {/* Sticky Glassmorphism Header */}
        <div className="sticky top-0 z-20 bg-white/70 backdrop-blur-xl border-b border-slate-200/50 shadow-sm px-4 py-3 sm:px-6 sm:py-4 flex items-center justify-between">
          <div className="flex items-center gap-3 sm:gap-4">
            <button 
              onClick={() => navigate(-1)} 
              className="text-indigo-600 bg-white border-2 border-indigo-100 hover:bg-indigo-50 hover:border-indigo-200 font-bold px-3 py-1.5 sm:px-5 sm:py-2.5 rounded-xl text-xs sm:text-sm transition-all shadow-sm flex items-center gap-1.5 active:scale-95"
            >
              <span className="text-[10px] sm:text-xs">←</span> Back
            </button>
            <h1 className="text-base sm:text-2xl font-extrabold text-slate-800 tracking-tight leading-none">
              Reward <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-violet-600">Journey</span>
            </h1>
          </div>
        </div>

        <div className="w-full max-w-3xl mx-auto px-4 pt-4">
  <MonetizationDashboard
    stats={monetizationStats}
    loading={loadingMonetization}
  />
</div>

        {/* Scrollable Journey Container */}
        <div ref={scrollRef} className="flex-1 overflow-y-auto flex justify-center pt-6 pb-20 px-2 sm:px-4 custom-scrollbar">
          
          {/* Responsive SVG Canvas */}
          <svg
            viewBox={`0 0 ${SVG_WIDTH} ${SVG_HEIGHT}`}
            className="w-full max-w-[600px] h-auto drop-shadow-xl"
          >
            <defs>
              <filter id="greyscale">
                  <feColorMatrix type="matrix" values="0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"/>
              </filter>
            </defs>

            {/* 1. The Curving Road Path */}
            <path
              d={roadPathD}
              fill="none"
              stroke="rgba(255,255,255,0.6)"
              strokeWidth="60"
              strokeLinecap="round"
            />
            <path
              d={roadPathD}
              fill="none"
              stroke="#6366f1" // Indigo-500
              strokeWidth="8"
              strokeDasharray="20,15"
              strokeLinecap="round"
            />

            {/* 2. The Stops */}
            {journeyData.map((stop, index) => {
              const { x, y } = getStopCoordinate(index);
              const circleSize = 80; 
              const imageSize = 50;  
              const isLast = index === journeyData.length - 1;

              return (
                <g
                  ref={isLast ? lastStopRef : null}
                  key={stop.id}
                  transform={`translate(${x}, ${y})`} 
                  style={{
                    cursor: stop.isUnlocked && !isLevelClaimed(stop.id) ? "pointer" : "not-allowed"
                  }}
                  onClick={() => {
                    if (stop.id % 10 === 0 && stop.isUnlocked && !isLevelClaimed(stop.id)) {
                      setActiveGift(stop.id);
                      setShowGift(true);
                      trackClick("Reward Options Opened");
                    }
                  }}
                >
                  {/* Outer glow/ring */}
                  <circle
                    r={circleSize / 2 + 8}
                    fill={isLevelClaimed(stop.id) ? "#e2e8f0" : stop.id % 10 === 0 && stop.isUnlocked ? "#d1fae5" : "#f1f5f9"}
                    stroke={isLevelClaimed(stop.id) ? "#cbd5e1" : stop.id % 10 === 0 && stop.isUnlocked ? "#10b981" : "#e2e8f0"}
                    strokeWidth={isLevelClaimed(stop.id) ? "2" : "4"}
                    opacity="0.9"
                  />

                  {/* Main background circle */}
                  <circle
                    r={circleSize / 2}
                    fill={isLevelClaimed(stop.id) ? "#f8fafc" : "white"}
                    stroke={isLevelClaimed(stop.id) ? "#cbd5e1" : stop.id % 10 === 0 && stop.isUnlocked ? "#059669" : "#cbd5e1"}
                    strokeWidth="3"
                    className={stop.id % 10 === 0 && stop.isUnlocked && !isLevelClaimed(stop.id) ? "pulsing-circle" : ""}
                  />

                  {/* Icon/Image */}
                  <image
                    href={stop.imageSrc}
                    x={-imageSize / 2}
                    y={-imageSize / 2}
                    height={imageSize}
                    width={imageSize}
                    filter={!stop.isUnlocked || isLevelClaimed(stop.id) ? "url(#greyscale)" : ""}
                    style={{ opacity: isLevelClaimed(stop.id) ? 0.6 : stop.isUnlocked ? 1 : 0.7 }}
                  />

                  {/* Level Label */}
                  <text
                    y={circleSize / 2 + 25}
                    textAnchor="middle"
                    className="text-[14px] font-extrabold font-sans"
                    fill={stop.isUnlocked ? "#334155" : "#94a3b8"}
                  >
                    {stop.id % 10 === 0
                      ? isLevelClaimed(stop.id) ? "Gift Card Claimed" : stop.isUnlocked ? "Gift Card Unlocked" : "Gift Card Locked"
                      : stop.isUnlocked ? `Reward ${stop.id} - Points Unlocked` : `Reward ${stop.id} - Points Locked`}
                  </text>

                  {/* Reward Title */}
                  <text
                      y={-circleSize / 2 - 15}
                      textAnchor="middle"
                      className="text-[12px] font-bold font-sans pointer-events-none"
                      fill="#64748b"
                  >
                      {stop.rewardTitle}
                  </text>
                </g>
              );
            })}

            {/* START Pointer */}
            <g transform={`translate(${CENTER_X}, ${START_POINTER_Y})`}>
              <line x1="0" y1="0" x2="0" y2="22" stroke="#4f46e5" strokeWidth="6" strokeLinecap="round" />
              <polygon points="-8,22 8,22 0,32" fill="#4f46e5" />
              <text y="-10" textAnchor="middle" className="text-[12px] font-black tracking-widest font-sans" fill="#4f46e5">
                START
              </text>
            </g>

          </svg>
        </div>

        {/* Modal Overlays */}
        {showGift && (
          <div className="fixed inset-0 bg-slate-900/70 backdrop-blur-sm z-[9999] flex items-center justify-center p-4 animate-in fade-in duration-200">
            
            {/* ================= FINAL CONFIRMATION SCREEN ================= */}
            {finalReward ? (
              <div className="bg-white p-6 sm:p-8 rounded-2xl sm:rounded-3xl shadow-2xl text-center w-full max-w-sm animate-in zoom-in-95 duration-300">
                <img
                  src={
                    finalReward.rewardIndex === 1 ? "/Amazon_Gift_Card.jpg"
                    : finalReward.rewardIndex === 2 ? "/KFC_Reward.png"
                    : "/Dominos_Reward.png"
                  }
                  className="w-32 sm:w-40 mx-auto mb-4 sm:mb-6 rounded-xl shadow-sm"
                  alt="Reward"
                />
                <p className="text-sm sm:text-base font-bold text-slate-700 mb-6 leading-relaxed">
                  🎉 Your gift card will be delivered in <br />
                  <span className="text-emerald-600 text-lg sm:text-xl font-black">24 hours</span>
                </p>
                <button
                  onClick={() => {
                    setFinalReward(null);
                    setShowGift(false);
                    setOtpStep(null);
                    setPhone("");
                    setOtp("");
                    recaptchaVerifier.current?.clear();
                    recaptchaVerifier.current = null;
                  }}
                  className="w-full bg-slate-900 text-white font-bold py-3 sm:py-3.5 rounded-xl sm:rounded-2xl hover:bg-slate-800 transition-colors shadow-lg"
                >
                  Awesome, Close!
                </button>
              </div>
            ) : (

              /* ================= MAIN REWARD / OTP MODAL ================= */
              <div className="bg-white rounded-2xl sm:rounded-3xl p-5 sm:p-8 w-full max-w-md relative shadow-2xl animate-in zoom-in-95 duration-300">
                
                {/* ❌ Close Button */}
                <button
                  onClick={() => {
                    setShowGift(false);
                    setOtpStep(null);
                    setPhone("");
                    setOtp("");
                    recaptchaVerifier.current?.clear();
                    recaptchaVerifier.current = null;
                  }}
                  className="absolute top-4 right-4 sm:top-5 sm:right-5 bg-slate-100 hover:bg-rose-100 text-slate-500 hover:text-rose-600 w-8 h-8 rounded-full flex items-center justify-center font-bold transition-colors"
                >
                  ✕
                </button>

                {/* ================= STEP 0: CHOOSE REWARD ================= */}
                {otpStep === null && (
                  <>
                    <h3 className="text-xl sm:text-2xl font-black text-slate-800 text-center mb-6 pr-4">
                      Choose Your Reward 🎁
                    </h3>
                    <div className="grid grid-cols-2 gap-3 sm:gap-4">
                      {[1, 2, 3].map((rewardIndex) => (
                        <div key={rewardIndex} className="bg-slate-50 border border-slate-200 p-3 sm:p-4 rounded-xl sm:rounded-2xl flex flex-col items-center justify-between hover:border-indigo-300 hover:shadow-md transition-all group">
                          <img
                            src={
                              rewardIndex === 1 ? "/Amazon_Gift_Card.jpg"
                              : rewardIndex === 2 ? "/KFC_Reward.png"
                              : "/Dominos_Reward.png"
                            }
                            className="w-full max-w-[80px] sm:max-w-[100px] mb-3 sm:mb-4 rounded-lg group-hover:scale-105 transition-transform"
                            alt="Gift"
                          />
                          <button
                            onClick={() => {
                              setSelectedRewardIndex(rewardIndex);
                              setOtpStep("PHONE");
                            }}
                            className="w-full bg-slate-900 text-white font-bold py-2 sm:py-2.5 rounded-lg sm:rounded-xl text-[10px] sm:text-xs hover:bg-indigo-600 transition-colors shadow-sm"
                          >
                            Claim This
                          </button>
                        </div>
                      ))}
                    </div>
                  </>
                )}

                {/* ================= STEP 1: PHONE ================= */}
                {otpStep === "PHONE" && (
                  <div className="pt-2">
                    <h3 className="text-xl sm:text-2xl font-black text-slate-800 text-center mb-2">Verify Phone 📱</h3>
                    <p className="text-center text-xs sm:text-sm text-slate-500 mb-6">Enter your mobile number to claim your reward.</p>

                    <input
                      type="tel"
                      placeholder="10-digit mobile number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      className="w-full bg-slate-50 border-2 border-slate-200 rounded-xl px-4 py-3 sm:py-4 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 outline-none font-bold text-slate-700 transition-all text-sm sm:text-base text-center tracking-widest placeholder:tracking-normal"
                    />

                    {otpError && <p className="text-rose-500 text-xs sm:text-sm font-bold text-center mt-3 animate-pulse">{otpError}</p>}

                    <button
                      onClick={sendOtp}
                      disabled={sendingOtp}
                      className="mt-6 w-full bg-gradient-to-r from-indigo-600 to-violet-600 text-white font-bold py-3.5 sm:py-4 rounded-xl sm:rounded-2xl hover:shadow-lg hover:shadow-indigo-500/30 transition-all disabled:opacity-50"
                    >
                      {sendingOtp ? "Sending OTP..." : "Send OTP ➡️"}
                    </button>
                  </div>
                )}

                {/* ================= STEP 2: OTP ================= */}
                {otpStep === "OTP" && (
                  <div className="pt-2">
                    <h3 className="text-xl sm:text-2xl font-black text-slate-800 text-center mb-2">Enter OTP 🔐</h3>
                    <p className="text-center text-xs sm:text-sm text-slate-500 mb-6">
                      Code sent securely to <strong className="text-slate-800">+91 {phone}</strong>
                    </p>

                    <input
                      type="number"
                      placeholder="6-digit OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      className="w-full bg-slate-50 border-2 border-slate-200 rounded-xl px-4 py-3 sm:py-4 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 outline-none font-bold text-slate-700 transition-all text-lg sm:text-xl text-center tracking-[0.5em] placeholder:tracking-normal"
                    />

                    {otpError && <p className="text-rose-500 text-xs sm:text-sm font-bold text-center mt-3 animate-pulse">{otpError}</p>}

                    <button
                      onClick={verifyOtp}
                      className="mt-6 w-full bg-emerald-500 text-white font-bold py-3.5 sm:py-4 rounded-xl sm:rounded-2xl hover:bg-emerald-600 shadow-lg hover:shadow-emerald-500/30 transition-all"
                    >
                      ✅ Verify & Claim
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

      </div>
    </>
  );
}


function InfoTooltip({ text }) {
  return (
    <span className="relative inline-flex group">
      <button
        type="button"
        aria-label={text}
        className="text-emerald-500 hover:text-emerald-700 focus:outline-none"
      >
        <Info className="w-3 h-3" />
      </button>

      <span className="pointer-events-none absolute left-1/2 top-full z-50 mt-1 hidden w-44 -translate-x-1/2 rounded-lg bg-gray-900 px-2 py-1.5 text-[10px] font-medium leading-snug text-white shadow-lg group-hover:block group-focus-within:block">
        {text}
      </span>
    </span>
  );
}

function MonetizationDashboard({ stats, loading }) {
  const lessonCount = stats?.lessonCount || 0;
  const worksheetCount = stats?.worksheetCount || 0;
  const totalDownloadsCount = stats?.totalDownloadsCount || 0;
  const estimatedEarnings = lessonCount + worksheetCount + totalDownloadsCount;

const items = [
  {
    label: 'Your Approved Lessons',
    value: lessonCount,
    Icon: BookOpen,
    info: '5 Reward Levels Per Approved Lesson',
    subtext:'5 Reward Levels per Lesson'
  },
  {
    label: 'Downloads of your Worksheets',
    value: totalDownloadsCount,
    Icon: Download,
    info: '1 Reward Level per downloaded worksheet,downloaded by a new parent everytime',
    subtext:'1 Reward Level per download'
  },
];

  return (
    <div className="w-full bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 rounded-xl px-2 py-1.5 md:px-3 md:py-2 shadow-sm relative overflow-hidden">
      <IndianRupee className="absolute -right-4 -bottom-5 w-20 h-20 text-emerald-600/5 pointer-events-none" />

      {loading ? (
        <p className="relative z-10 text-[10px] md:text-xs font-bold text-emerald-700">
          Loading earnings...
        </p>
      ) : (
        <div className="relative z-10 grid grid-cols-[1fr_auto] gap-2 items-center">
          <div className="grid grid-cols-2 gap-1.5 md:gap-2 min-w-0">
            {items.map(({ label, value, Icon,info,subtext  }) => (
              <div key={label} className="bg-white/70 border border-emerald-100 rounded-lg px-1.5 py-1 md:px-2 md:py-1.5 min-w-0">
                <div className="flex items-start gap-1 text-emerald-700">
                  <Icon className="hidden sm:block w-3 h-3 shrink-0 mt-0.5" />
                  <div className="flex items-start gap-1 min-w-0">
                    <p className="text-[8px] md:text-[10px] font-bold uppercase leading-tight">
                      {label}
                    </p>
                    <InfoTooltip text={info} />
                  </div>
                </div>
                <p className="mt-0.5 text-xs md:text-sm font-black text-gray-800">
                  {value} <span className="text-[9px] md:text-[10px] font-normal text-gray-500">{subtext}</span>
                </p>
              </div>
            ))}
          </div>

      {/*    <div className="bg-emerald-600 text-white rounded-lg px-2 py-1.5 md:px-3 md:py-2 min-w-[72px] text-center shadow-sm">
            <div className="flex items-center justify-center gap-1">
              <p className="text-[8px] md:text-[10px] font-bold uppercase leading-none text-emerald-100">
                Total
              </p>
              <InfoTooltip text="Total estimated earnings: lessons plus worksheets plus downloads." />
            </div>
            <div className="mt-1 flex items-center justify-center text-lg md:text-xl font-black">
              <IndianRupee className="w-4 h-4 md:w-5 md:h-5 stroke-[3]" />
              {estimatedEarnings}
            </div>
          </div>
        */}
        
        </div>
      )}
    </div>
  );
}





export default RewardJourney;